import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { notify } from '../utils/notify';
import { HiMail, HiArrowLeft } from 'react-icons/hi';
import { useTranslation } from 'react-i18next';


export default function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const { forgotPassword } = useAuthStore();
    const { t, i18n } = useTranslation();


    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        const result = await forgotPassword(email, i18n.language);

        if (result.success) {
            setIsSubmitted(true);
            notify.success(t('forgot_password.check_email_success'));
        } else {
            notify.error(result.error);
        }

        setIsLoading(false);
    };

    if (isSubmitted) {
        return (
            <div className="text-center space-y-6">
                <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mx-auto">
                    <svg className="w-8 h-8 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                </div>
                <div>
                    <h2 className="text-2xl font-bold text-white">{t('forgot_password.check_email')}</h2>
                    <p className="text-slate-400 mt-2">
                        {t('forgot_password.instructions_sent')}<br />
                        <span className="text-white font-medium">{email}</span>
                    </p>
                </div>
                <Link to="/login" className="btn-secondary inline-flex items-center gap-2">
                    <HiArrowLeft className="w-4 h-4" />
                    {t('forgot_password.back_to_login')}
                </Link>
            </div>
        );
    }

    return (
        <div className="space-y-8">
            <div>
                <h2 className="text-2xl font-bold text-white">{t('forgot_password.reset_password')}</h2>
                <p className="text-slate-400 mt-2">{t('forgot_password.enter_email_instructions')}</p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                    <label htmlFor="email" className="block text-sm font-medium text-slate-300 mb-1.5">
                        {t('login.email_address')}
                    </label>
                    <div className="relative">
                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <HiMail className="w-5 h-5 text-slate-500" />
                        </div>
                        <input
                            id="email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="input pl-10 bg-slate-800 border-slate-700 text-white"
                            placeholder="you@example.com"
                            required
                        />
                    </div>
                </div>

                <button
                    type="submit"
                    disabled={isLoading}
                    className="btn-primary w-full py-3"
                >
                    {isLoading ? (
                        <span className="flex items-center justify-center gap-2">
                            <svg className="animate-spin w-5 h-5" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                            </svg>
                            {t('forgot_password.sending')}
                        </span>
                    ) : (
                        t('forgot_password.send_reset_link')
                    )}
                </button>
            </form>

            <Link to="/login" className="flex items-center justify-center gap-2 text-slate-400 hover:text-white">
                <HiArrowLeft className="w-4 h-4" />
                {t('forgot_password.back_to_login')}
            </Link>
        </div>
    );
}
